import { render, staticRenderFns } from "./MasterDataDiagnose.vue?vue&type=template&id=ca0602a8&scoped=true"
import script from "./MasterDataDiagnose.vue?vue&type=script&lang=js"
export * from "./MasterDataDiagnose.vue?vue&type=script&lang=js"
import style0 from "./MasterDataDiagnose.vue?vue&type=style&index=0&id=ca0602a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0602a8",
  null
  
)

export default component.exports